module.exports = __webpack_public_path__ + "static/media/englishPage1.b457cfaa.jpg";